export const JOIN_CLASS_DIALOG_STEPPER_STEPS = 5;
export const JOIN_CLASS_DIALOG = 'joinClassDialog';